/**
 * The prompt Solution Engineers send to Claude together with the ticket
 * export, to get the Automation Opportunities and KB Articles PDF reports.
 * Only the ITSM name varies per tenant.
 */
export function ticketReportPrompt(itsmName: string): string {
  return `I'm analyzing historical helpdesk tickets from ${itsmName}. I want to create PDF reports:

1. Automation Opportunities - Find repetitive patterns that can be automated. For each pattern share a title, count and percentage, and a few examples. Sort by percentage descending. Aggregate all application/software access requests into one category.

2. Knowledge Base Articles - Learnings that can be converted into KB articles for self-serve use. Learn from the description and comments to generate full KB articles with step-by-step instructions.

Tips for best results:
• The more tickets you have, the better the pattern detection.
• If you want specific applications called out separately (instead of aggregated), just mention that.
• You can also ask for specific output formats (PDF, Word, Excel, React artifacts, etc.).
• Don't create basic knowledge base articles. Try to create employee-facing ones, with relevant interesting and specific data.
• Don't create knowledge base articles for things like password resets, app access, MFA reset, email group management, user lockout, laptop access restore.
• Create 15 KBs.
• Don't add any branding to the pages, keep them simple.`;
}

/** Import-provider label without its auth-variant suffix, e.g. "ServiceNow (OAuth)" → "ServiceNow". */
export function itsmDisplayName(providerLabel: string): string {
  return providerLabel.replace(/\s*\(.*\)$/, "");
}
